<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('云种植气候.气候名称')" prop="climateName">
        <a-input v-model="form.climateName" :maxLength="50" :placeholder="$t('通用.输入.请输入') + $t('云种植气候.气候名称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植气候.封面图')" prop="coverImage">
        <OssUploadSingle v-model="form.coverImage" type="img" :maxSize="200"></OssUploadSingle>
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植气候.气候说明')" prop="description">
        <a-textarea v-model="form.description" :maxLength="500" :rows="3" :placeholder="$t('通用.输入.请输入') + $t('云种植气候.气候说明')" allow-clear />
      </a-form-model-item>

      <a-form-model-item :label="$t('云种植气候.盲盒种子说明')" prop="blindBoxDesc">
        <a-textarea v-model="form.blindBoxDesc" :maxLength="500" :rows="3" :placeholder="$t('通用.输入.请输入') + $t('云种植气候.盲盒种子说明')" allow-clear />
      </a-form-model-item>

<!--      <a-form-model-item :label="$t('云种植气候.状态')" prop="status">-->
<!--        <a-radio-group v-model="form.status">-->
<!--          <a-radio v-for="(item, index) in customDict.IEnum" :key="index" :value="item.type">-->
<!--            {{ item.name }}-->
<!--          </a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('云种植气候.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
        <span style="margin-left: 10px; color: #999">{{ $t('云种植气候.排序提示') }}</span>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
          <a-button @click="cancel">{{ $t('通用.按钮.取消') }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getClimate, addClimate, updateClimate } from '@/api/cloudplant/climate'
import OssUploadSingle from '@/components/OssUploadSingle'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      formTitle: '',
      open: false,
      formType: 1,
      form: {
        id: null,
        climateName: null,
        coverImage: null,
        description: null,
        blindBoxDesc: null,
        status: 1,
        sort: 0
      },
      rules: {
        climateName: [{ required: true, message: this.$t('云种植气候.气候名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        climateName: null,
        coverImage: null,
        description: null,
        blindBoxDesc: null,
        status: 1,
        sort: 0
      }
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      getClimate({ id: row.id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateClimate(this.form)
              .then(() => {
                this.$message.success(this.$t('通用.文本.修改成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addClimate(this.form)
              .then(() => {
                this.$message.success(this.$t('通用.文本.新增成功'))
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        }
      })
    }
  }
}
</script>
